export default __webpack_public_path__ + "static/media/forward_thin_00adef.55407530.svg";